var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"logoContainer",attrs:{"to":"/home"}},[_c('img',{attrs:{"src":_vm.importImg('logo.png'),"alt":"Stomerij"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }